import React from 'react';
import { Spin, Icon } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';


export default function LoadingIndicator(props) {
    return (
        <LoadingOutlined spin style = {{display: 'block', textAlign: 'center', marginTop: 50, fontSize: 30 }}/>
    );
}  